import React from "react";
import "./Aboutheader.css";

/**
 * Props:
 *  - bgSrc    : string  -> image path or imported asset
 *  - focusY   : number  -> vertical focus in %, default 35 (shows faces)
 *  - darkness : number  -> 0..1 overlay strength, default 0.45
 *
 * Usage with /public:
 *  <Aboutheader bgSrc="/images/about-header.jpg" />
 *
 * Usage with imported asset:
 *  import hero from "../../assets/about-header.jpg";
 *  <Aboutheader bgSrc={hero} />
 */
export default function Aboutheader({ bgSrc, focusY = 0, darkness = 0.45 }) {
  const fallback = `${process.env.PUBLIC_URL || ""}/hhhr.jpg`;
  const bgUrl = bgSrc || fallback;

  return (
    <section
      className="about-header"
      style={{
        "--about-bg": `url("${bgUrl}")`,
        "--focus-y": `${focusY}%`,
        "--overlay": darkness,
      }}
      aria-label="About page header"
    >
      <div className="about-header__overlay" aria-hidden="true" />
      <div className="about-header__content">
        <h1 className="about-header__title">ABOUT ME</h1>
        <span className="about-header__underline" aria-hidden="true" />
      </div>
    </section>
  );
}
